import React,{useRef ,useState, useEffect} from 'react'
import { useNavigate } from 'react-router-dom';

const FormComponent = () => {
  
  const navigate = useNavigate();


  return (
    
    <div className="shadow drop-shadow-sm bg-white p-8 mt-16 rounded-lg">
      <h2 className='note text-xl text-textmain'>
        <span className='font-bold'>NOTE: </span>
        <span className='text text-black'>
        The payment must be in the above given details before submitting this Form And Transaction Proof(*pdf) must be submitted at the time of submission of paper
        </span>
        
      </h2>
      <div className="relative w-full flex justify-center">
      <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSfODUBlP9dJpzrI4KBWIWYAfBNaQCAKFZ0RzZ4astwlEyeNiQ/viewform?embedded=true" width="700" height="520" frameborder="20" marginheight="0" marginwidth="0">Loading…</iframe>
      </div>
      <div className='flex justify-center'>
      <button
          className=" my-8 rounded-xl drop-shadow-xl  bg-textmain font-textFont text-white ring-2 ring-textmain  px-5 py-2.5 text-center text-sm font-medium   hover:ring-4 hover:text-black focus:outline-none focus:ring-4 focus:ring-blue-200 dark:focus:ring-blue-900"
          onClick={() => navigate('/submission')}
        >Click Here after Completing Your Registration
        </button>
      </div>

    </div>
  )
}
export default FormComponent